import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";

interface IDurationLabelNormalProps {
  displayContent: string;
}

export const DurationLabelNormal: FC<IDurationLabelNormalProps> = ({
  displayContent,
}) => {
  const { t } = useTranslation();
  return (
    <FramerTooltip
      placement={PopoverPlacement.bottom}
      content={t("ride.formLabel.totalDuration")}
    >
      <label data-e2e="ride-total-duration" className="rideTotalDurationLabel">
        {displayContent}
      </label>
    </FramerTooltip>
  );
};
